import { Glyphicon } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Button from 'components/button/Button';
import Tooltip from 'components/tooltip/Tooltip';
import {
  IntegrationEnum,
  IntegrationStatus,
  InternalIntegrationSetting,
} from 'models/InternalIntegrationSetting';
import { INTEGRATIONS_WITH_FREE_TRIAL } from 'pages/integrations/IntegrationsTabs.constants';
import useIntegrationDescriptionModal from 'pages/integrations/modals/integrationDescription/useIntegrationDescriptionModal';
import AccessLink from './AccessLink';
import TrialAvailableCta from './TrialAvailableCta';

interface IntegrationCellActionsProps {
  integrationSetting: InternalIntegrationSetting;
}

const IntegrationCellActions = ({
  integrationSetting,
}: IntegrationCellActionsProps) => {
  const { t } = useTranslation();
  const { openIntegrationDescriptionModal } = useIntegrationDescriptionModal();
  const { status, hasEnrolledBefore } = integrationSetting.agencySettings;
  const isIntegrationEnabled = status === IntegrationStatus.ACTIVE;
  const integrationId = integrationSetting.integration.enumId;

  const shouldShowTooltip = [
    IntegrationEnum.STRIPE,
    IntegrationEnum.PAYPAL,
  ].includes(integrationId);

  const showTrialCta =
    INTEGRATIONS_WITH_FREE_TRIAL.includes(integrationId) &&
    status !== IntegrationStatus.NOT_SUPPORTED &&
    !isIntegrationEnabled &&
    !hasEnrolledBefore;

  if (showTrialCta) {
    return <TrialAvailableCta integrationId={integrationId} />;
  }

  return (
    <>
      <div>
        <Button
          bsStyle="link"
          onClick={(e) => {
            e.stopPropagation();
            openIntegrationDescriptionModal(integrationSetting);
          }}
          data-testid="integration-description-button"
        >
          {t('pageIntegrations.table.viewDescription')}
        </Button>

        {shouldShowTooltip && (
          <Tooltip
            text={t('pageIntegrations.table.paymentProcessorWarning')}
            id="transaction-fee-tooltip"
          >
            <Glyphicon
              glyph="info-sign"
              data-testid="transaction-fee-tooltip"
            />
          </Tooltip>
        )}
      </div>

      {isIntegrationEnabled && <AccessLink integrationId={integrationId} />}
    </>
  );
};

export default IntegrationCellActions;
